<template>
    <CardUploadFiles
        :titleCard="'Precisamos verificar a lateral do seu veículo'"
        :cardDescription="'vehicle_side'"
        :textCard="'Lateral do veículo'"
        :srcExampleImage="ImageFrontVehicle"
        :nextRoute="'SavedVehicleFiles'"
        :previewScreen="'PreviewVehicleFiles'"
    />
</template>
<script>
    import CardUploadFiles from '../../components/CardUploadFiles.vue'
    import ImageFrontVehicle from '../../../../public/images/side.svg'
   
    export default {
        components: {
            CardUploadFiles
        },
        setup() {
            return {          
                ImageFrontVehicle
            };
        }, 
    }
</script>